<template>
  <div class="subjective-mark" v-show="visible">
    <div class="sm-content">
      <div class="sm-title">给主观题打分</div>
      <div class="sm-main">
        <template v-for="(elem, index) in questionsMap">
          <div :key="index" v-if="elem.quesTypeID === 5">
            <div class="sm-questype">
              {{elem.viewTypeName}}
            </div>
            <div v-for="(ans, index2) in elem.list" :key="index2">
              <div class="sm-list">
                <div class="jx_tm">
                  <a :id="ans.questionID" v-html="'<' + (index2 + 1) + '>、' + ans.content"/>
                </div>
                <template v-for="(smallQues, index3) in ans.smallContent">
                  <div class="jx_tmtit" :key="index3 + 'g'">
                    <a :id="smallQues.questionID" v-html="(index3 + 1) + '、' + smallQues.content"/>
                  </div>
                  <div class="jx_zqda" :key="index3 + 'i'">
                    <div>【<span style="color: rgb(204, 51, 0);">本题{{smallQues.score}}分</span>】</div>
                    <div v-html="smallQues.userAnswer ? `【<span style='color: rgb(6, 88, 224);'>您的答案</span>】：${smallQues.userAnswer}` : `【<span style='color: rgb(6, 88, 224);'>您的答案</span>】：您未做该题`"></div>
                    <div v-html="`【<span style='color: rgb(255, 0, 0);'>正确答案</span>】：${smallQues.answer}`"></div>
                    <div v-if="hasAnswer(smallQues)">
                      <span>【<span style="color: rgb(38, 177, 94);">输入本题得分</span>】</span>
                      <input type="text" v-model="smallQues.userScore" @blur="validateItem(smallQues)">
                      <span v-if="smallQues.subTips" class="validate">{{smallQues.subTips}}</span>
                    </div>
                    <br>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="sm-buttom clearfix">
        <div class="sm-button fl" @click="submitPaper">提&emsp;&emsp;交</div>
        <div class="sm-button fl" @click="close">关&emsp;&emsp;闭</div>
      </div>
    </div>
    <div class="sm-mask"></div>
  </div>
</template>
<script>
  export default {
    props: {
      questionsMap: { type: Array, required: true },
      visible: { type: Boolean, default: true },
    },
    data() {
      return {
        validateResult: '',
      }
    },
    methods: {
      // 验证答题
      validateItem(question) {
        let isNumber = /^\d+((\.)?\d)?$/
        if (!question.userScore) {
          question.subTips = '请输入分数'
        } else if (!isNumber.test(question.userScore)) {
          question.subTips = '请输入整数或者一位小数！'
        } else if (question.userScore > question.score) {
          question.subTips = '输入的数字不能大于该题目的分值！'
        } else {
          question.subTips = ''
        }
        return question.subTips
      },
      submitPaper() {
        for (let key in this.questionsMap) {
          if (this.questionsMap[key] && this.questionsMap[key].quesTypeID === 5) {
            let validate = this.questionsMap[key].list.some((ques) => {
              let res = false
              if (ques.smallContent) {  //  存在答题套小题
                res = ques.smallContent.some((smallQues) => {
                  if (smallQues.attAnswer) {
                    return !!(smallQues.tempAnswer === 'true' ? (this.validateItem(smallQues)) : false)
                  } else {
                    return !!(this.validateItem(smallQues) && smallQues.userAnswer)
                  }
                })
              } else {
                // res = !!(this.validateItem(ques) && ques.userAnswer)
                if (ques.attAnswer) {
                  res = !!(ques.tempAnswer === 'true' ? (this.validateItem(ques)) : false)
                } else {
                  res = !!(this.validateItem(ques) && ques.userAnswer)
                }
              }
              return res
            })
            this.$forceUpdate()
            if (validate) {
              alert('主观题仍有未打分或不符合打分规范的情况，请查看打分后的提示！')
              return
            }
          }
        }
        this.$store.commit('SET_QUESTIONS',this.questionsMap)
        this.$emit('submit');
      },
      close() {
        this.$emit('close')
      },
      hasAnswer(ques) {  //  判断小题是否回答
        let res = false
        if (ques.attAnswer) {
          // res = (ques.tempAnswer === 'true')
          res = (ques.isAnswer === 1)
        } else {
          res = (ques.userAnswer && ques.userAnswer.length)
        }
        return res
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>